import { ref, computed, watch } from '@vue/composition-api'

export default function useVersionsList(ctx) {
  const tableColumns = [
    { key: 'label' },
    { key: 'effectiveDateTime', label: 'Effective Date' },
    { key: 'published' },
    { key: 'createdAt', label: 'Created At' },
    { key: 'actions', label: 'Actions' },
  ]

  const selectedZone = ref()
  const selectedService = ref()

  const perPage = ref(10)
  const totalVersions = ref(1)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25]

  const getVersionsList = computed(() => ctx.root.$store.getters['versions/getVersionsList'])
  const versionsLoading = ref(false)
  const fetchVersions = async () => {
    try {
      versionsLoading.value = true
      await ctx.root.$store.dispatch('versions/fetchVersions', {
        selectedZone: selectedZone.value,
        selectedService: selectedService.value,
        // businessId,
      })
      totalVersions.value = getVersionsList.value.length
    } catch (error) {
      console.log(error)
    } finally {
      versionsLoading.value = false
    }
  }

  watch([selectedZone, selectedService], () => {
    if (selectedZone.value && selectedService.value) {
      fetchVersions()
    }
    if (!selectedZone.value) {
      selectedService.value = undefined
    }
  })

  // fetchVersions()

  return {
    tableColumns,
    versionsLoading,
    selectedZone,
    selectedService,
    fetchVersions,
    getVersionsList,
    perPageOptions,
    perPage,
    currentPage,
    totalVersions,
  }
}
